import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';

import { changeProject, getProject } from '../../../redux/projects/projectsActions';
import { resetEditProjectPage } from '../../../redux/projects/projectsReducer';
import NameSection from '../name/NameSection';
import ShareSection from '../share/ShareSection';
import AccessUsersSection from '../access-users/AccessUsersSection';
import { resetId8Agents } from '../../../redux/id8/id8Reducer';
import { AGENT_TYPES } from '../../../constants';
import { addCustomAgent, editCustomAgent } from '../../../redux/settings/id8/id8SettingsActions';
import { getProjectAgent } from '../../../redux/id8/id8Actions';

import scss from './EditId8.module.scss';

function EditId8() {
  const { id } = useParams();
  const dispatch = useDispatch();

  const handleSaveNameSection = async ({ id, editProject, values }) => {
    const { projectName, instructions, thinking, agentId, agentType } = values;
    let newAgentId = agentId;

    if (agentType === AGENT_TYPES.CUSTOM && agentId !== AGENT_TYPES.CUSTOM) {
      await dispatch(editCustomAgent({ id: agentId, instructions }));
      await dispatch(getProjectAgent(agentId));
    } else if (agentType === AGENT_TYPES.CUSTOM && agentId === AGENT_TYPES.CUSTOM) {
      const createdAgent = await dispatch(addCustomAgent(instructions));

      newAgentId = createdAgent.payload.id;
    }

    await dispatch(
      changeProject({
        id,
        projectType: editProject.projectType,
        values: { projectName, thinking, agentId: newAgentId },
      }),
    );
  };

  useEffect(() => {
    dispatch(getProject({ id }));

    return () => {
      dispatch(resetEditProjectPage());
      dispatch(resetId8Agents());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={scss.pageWrapper}>
      <NameSection onSubmit={handleSaveNameSection} />
      <ShareSection />
      <AccessUsersSection />
    </div>
  );
}

export default EditId8;
